import { useAppDispatch, useAppSelector } from 'app/hooks';
import Modal from 'components/common/modal';
import ActiveItemAttributes, {
  ActiveItemAttributesRef
} from 'components/structure-page/active-item-attributes';
import { setActiveItem } from 'features/ui';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { conflictModal } from 'utils/ui';

type AttributeModalProps = {
  openState: [boolean, Dispatch<SetStateAction<boolean>>];
  currentSectionId?: string;
};

export default function AttributeModal({
  openState,
  currentSectionId
}: AttributeModalProps) {
  const dispatch = useAppDispatch();
  const { activeItem } = useAppSelector((state) => state.ui);
  const activeItemAttributesRef = useRef<ActiveItemAttributesRef>(null);
  const [itemName, setItemName] = useState(activeItem?.label);
  const [, setOpen] = openState;

  useEffect(() => {
    setItemName(activeItem?.label);
  }, [activeItem]);

  const handleRename = (value: string) => {
    setItemName(value);
  };

  const handleSave = () => {
    activeItemAttributesRef.current?.handleSave();
  };

  const beforeClose = () => {
    if (activeItemAttributesRef.current?.hasUnsavedChanges()) {
      conflictModal({
        title: 'Unsaved Changes',
        message:
          'You have unsaved changes. Do you want to save them before closing?',
        confirmAction: () => {
          handleSave();
          setOpen(false);
          dispatch(setActiveItem(null));
        },
        cancelAction: () => {
          setOpen(false);
          dispatch(setActiveItem(null));
        },
        confirmButtonText: 'Save Changes',
        cancelButtonText: 'Discard Changes'
      });
      return false;
    }
    return true;
  };

  return (
    <Modal
      title={activeItem?.label || 'Unknown Item'}
      openState={openState}
      onClose={() => dispatch(setActiveItem(null))}
      onRename={handleRename}
      defaultRename={!activeItem?.attributes?.length}
      renameSizeLimit={25}
      size='xl'
      onSave={handleSave}
      beforeClose={beforeClose}
    >
      <ActiveItemAttributes
        ref={activeItemAttributesRef}
        itemName={itemName}
        currentSectionId={currentSectionId}
      />
    </Modal>
  );
}
